import Pager from '@/components/PagerComponent'

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { useVuelidate } from '@vuelidate/core'
import { requiredIf, requiredUnless, minLength, maxLength, numeric } from '@vuelidate/validators'

import { Schemes } from '@/enums/schemes.enum'
import { TransactionCategories } from '@/enums/transaction-categories.enum'
import { TechnicalStatuses } from '@/enums/technical-statuses.enum'

import { useToast } from 'vue-toast-notification';

export default {

  components: {
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      criterias: {
        selectedDistributorRef: '',
        selectedScheme: 'MCI',
        selectedPan: '',
        selectedCardId: '',
        selectedIdOperation: '',
        selectedNumAut: '',
        selectedClasseTransaction: '',
        selectedTransactionStatus: '',
        selectedDateTransactionBegin: dayjs().format('YYYY-MM-DD'),
        selectedTimeTransactionBegin: '00:00:01',
        selectedDateTransactionEnd: dayjs().format('YYYY-MM-DD'),
        selectedTimeTransactionEnd: '23:59:59',
        selectedDateTraitementBegin: '',
        selectedTimeTraitementBegin: '',
        selectedDateTraitementEnd: '',
        selectedTimeTraitementEnd: '',
        selectedTransactionAmount: '',
        selectedCurrencyCode: ''
      },
      displayedCompensations: [],
      distributors: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      schemes: Schemes,
      transactionClasses: TransactionCategories,
      technicalStatuses: TechnicalStatuses,
      isDistributorLocked: false,
      properties: [
        'clearing.distributorRef',
        'clearing.cardSchemeCode',
        'clearing.pan',
        'clearing.classeTransaction',
        'clearing.dateTransaction',
        'clearing.processingDate',
        'clearing.transactionAmount',
        'clearing.reversalFlag'
      ]
    }
  },

  created () {
    if(this.$store.state.clearings.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.clearings.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('clearings/resetInvalidData')
    this.$store.dispatch('clearings/resetClearing')
    this.$store.dispatch('clearings/resetDetail')
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.getDistributors(user)
    this.getCriterias(user)
  },

  methods: {
    search () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.$store.dispatch('clearings/setCriterias', this.criterias)
        this.getClearings()
      }
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
      if (user.ihmDistribRef) {
        this.criterias.selectedDistributorRef = user.ihmDistribRef
        this.isDistributorLocked = true
      }
    },

    async getCriterias (user) {
      if(this.$store.state.clearings.criterias && this.$store.state.clearings.clearings.length > 0) {
        this.criterias = this.$store.state.clearings.criterias
      }
      if (user.ihmDistribRef) { // Au cas où le distributeur serait changé
        this.criterias.selectedDistributorRef = user.ihmDistribRef
      }
    },

    async getClearings () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('clearings/reset')
      if (this.criterias.selectedDateTraitementBegin && this.criterias.selectedDateTraitementEnd) {
        this.criterias.selectedTimeTraitementBegin = '00:00:01'
        this.criterias.selectedTimeTraitementEnd = '23:59:59'
      }
      await this.$store.dispatch('clearings/search', {
        distributorRef: this.criterias.selectedDistributorRef,
        scheme: this.criterias.selectedScheme,
        pan: this.criterias.selectedPan,
        cardId: this.criterias.selectedCardId,
        idOperation: this.criterias.selectedIdOperation,
        numAut: this.criterias.selectedNumAut,
        classeTransaction: this.criterias.selectedClasseTransaction,
        transactionStatus: this.criterias.selectedTransactionStatus,
        dateTransactionBegin: this.criterias.selectedDateTransactionBegin && this.criterias.selectedTimeTransactionBegin ? this.criterias.selectedDateTransactionBegin.concat(' ').concat(this.criterias.selectedTimeTransactionBegin.length === 5 ? this.criterias.selectedTimeTransactionBegin.concat(':00') : this.criterias.selectedTimeTransactionBegin) : '',
        dateTransactionEnd: this.criterias.selectedDateTransactionEnd && this.criterias.selectedTimeTransactionEnd ? this.criterias.selectedDateTransactionEnd.concat(' ').concat(this.criterias.selectedTimeTransactionEnd.length === 5 ? this.criterias.selectedTimeTransactionEnd.concat(':00') : this.criterias.selectedTimeTransactionEnd) : '',
        dateTraitementBegin: this.criterias.selectedDateTraitementBegin && this.criterias.selectedTimeTraitementBegin ? this.criterias.selectedDateTraitementBegin.concat(' ').concat(this.criterias.selectedTimeTraitementBegin.length === 5 ? this.criterias.selectedTimeTraitementBegin.concat(':00') : this.criterias.selectedTimeTraitementBegin) : '',
        dateTraitementEnd: this.criterias.selectedDateTraitementEnd && this.criterias.selectedTimeTraitementEnd ? this.criterias.selectedDateTraitementEnd.concat(' ').concat(this.criterias.selectedTimeTraitementEnd.length === 5 ? this.criterias.selectedTimeTraitementEnd.concat(':00') : this.criterias.selectedTimeTraitementEnd) : '',
        transactionAmount: this.criterias.selectedTransactionAmount,
        currencyCode: this.criterias.selectedCurrencyCode
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    downloadCSV () {
      const csv = this.loadCSV()
      const hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = dayjs().format('YYYYMMDD_HHmmss').concat('.csv')
      hiddenElement.click()
    },

    loadCSV () {
      let csv = this.properties.map(this.getCSVHeaderLabel).join(';') + '\n'
      for (const line of this.$store.state.clearings.clearings) {
        csv += this.properties.map(key => this.formatCSVValue(key.replace('clearing.', ''), line[key.replace('clearing.', '')])).join(';') + '\n'
      }
      return csv
    },

    getCSVHeaderLabel (headerName) {
      return headerName.includes('classeTransaction') ? this.$i18n.t('label.clearing.detail.transaction'.concat(headerName.replace('clearing', ''))) : this.$i18n.t('label.'.concat(headerName))
    },

    formatCSVValue (key, value) {
      switch (key) {
        case 'dateTransaction':
        case 'processingDate':
          return value ? this.$filters.date(value) : value
        case 'transactionAmount':
          return value ? this.$filters.currency(value.amount, value.currency) : value
        default:
          return value
      }
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    async showDetails (clearing) {
      this.$store.dispatch('clearings/setClearingDetail', clearing)
      this.$router.push({ name: 'clearing-detail' })
    },

    reset () {
      this.$store.dispatch('clearings/reset')
      this.$store.dispatch('clearings/resetCriterias')
      this.validationError = false
      this.error = false
      if (!this.isDistributorLocked) {
        this.criterias.selectedDistributorRef = ''
      }
      this.criterias.selectedScheme = 'MCI'
      this.criterias.selectedPan = ''
      this.criterias.selectedCardId = ''
      this.criterias.selectedIdOperation = ''
      this.criterias.selectedNumAut = ''
      this.criterias.selectedClasseTransaction = ''
      this.criterias.selectedTransactionStatus = ''
      this.criterias.selectedDateTransactionBegin = dayjs().format('YYYY-MM-DD')
      this.criterias.selectedTimeTransactionBegin = '00:00:01'
      this.criterias.selectedDateTransactionEnd = dayjs().format('YYYY-MM-DD')
      this.criterias.selectedTimeTransactionEnd = '23:59:59'
      this.criterias.selectedDateTraitementBegin = ''
      this.criterias.selectedTimeTraitementBegin = ''
      this.criterias.selectedDateTraitementEnd = ''
      this.criterias.selectedTimeTraitementEnd = ''
      this.criterias.selectedTransactionAmount = ''
      this.criterias.selectedCurrencyCode = ''
    }
  },

  validations() {
    return {
      criterias: {
        selectedDistributorRef: {
          oneRequired () {
            return (
              this.criterias.selectedDistributorRef ||
              this.criterias.selectedCardId ||
              this.criterias.selectedPan ||
              this.criterias.selectedIdOperation
            )
          }
        },
        selectedScheme: {
        },
        selectedPan: {
          minLength: minLength(1),
          maxLength: maxLength(19),
          oneRequired () {
            return (
              this.criterias.selectedDistributorRef ||
              this.criterias.selectedCardId ||
              this.criterias.selectedPan ||
              this.criterias.selectedIdOperation
            )
          }
        },
        selectedCardId: {
          minLength: minLength(1),
          maxLength: maxLength(20),
          numeric,
          oneRequired () {
            return (
              this.criterias.selectedDistributorRef ||
              this.criterias.selectedCardId ||
              this.criterias.selectedPan ||
              this.criterias.selectedIdOperation
            )
          }
        },
        selectedIdOperation: {
          minLength: minLength(1),
          maxLength: maxLength(16),
          numeric,
          oneRequired () {
            return (
              this.criterias.selectedDistributorRef ||
              this.criterias.selectedCardId ||
              this.criterias.selectedPan ||
              this.criterias.selectedIdOperation
            )
          }
        },
        selectedNumAut: {
          minLength: minLength(6),
          maxLength: maxLength(6)
        },
        selectedClasseTransaction: {
        },
        selectedTransactionStatus: {
        },
        selectedDateTransactionBegin: {
          required: requiredUnless(function() { return this.criterias.selectedDateTraitementBegin }),
          rangeMax () {
            if (this.criterias.selectedDateTransactionBegin !== '' && this.criterias.selectedDateTransactionEnd !== '') {
              return Math.abs(dayjs(this.criterias.selectedDateTransactionEnd).diff(dayjs(this.criterias.selectedDateTransactionBegin), 'days')) <= 90
            }
            return true
          }
        },
        selectedTimeTransactionBegin: {
          required: requiredIf(function() { return this.criterias.selectedDateTransactionBegin })
        },
        selectedDateTransactionEnd: {
          required: requiredIf(function() { return this.criterias.selectedDateTransactionBegin }),
          rangeMax () {
            if (this.criterias.selectedDateTransactionBegin !== '' && this.criterias.selectedDateTransactionEnd !== '') {
              return Math.abs(dayjs(this.criterias.selectedDateTransactionEnd).diff(dayjs(this.criterias.selectedDateTransactionBegin), 'days')) <= 90
            }
            return true
          }
        },
        selectedTimeTransactionEnd: {
          required: requiredIf(function() { return this.criterias.selectedDateTransactionBegin })
        },
        selectedDateTraitementBegin: {
          required: requiredUnless(function() { return this.criterias.selectedDateTransactionBegin }),
          rangeMax () {
            if (this.criterias.selectedDateTraitementBegin !== '' && this.criterias.selectedDateTraitementEnd !== '') {
              return Math.abs(dayjs(this.criterias.selectedDateTraitementEnd).diff(dayjs(this.criterias.selectedDateTraitementBegin), 'days')) <= 90
            }
            return true
          }
        },
        selectedTimeTraitementBegin: {
        },
        selectedDateTraitementEnd: {
          required: requiredIf(function() { return this.criterias.selectedDateTraitementBegin }),
          rangeMax () {
            if (this.criterias.selectedDateTraitementBegin !== '' && this.criterias.selectedDateTraitementEnd !== '') {
              return Math.abs(dayjs(this.criterias.selectedDateTraitementEnd).diff(dayjs(this.criterias.selectedDateTraitementBegin), 'days')) <= 90
            }
            return true
          }
        },
        selectedTimeTraitementEnd: {
        },
        selectedTransactionAmount: {
        },
        selectedCurrencyCode: {
        }
      }
    }
  }
}
